import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IParsedQsParams } from '../../types/expectedQsParams';
import { EActionTypes } from '../../constants/actionTypes/page';
import { EDealType } from '../../types/dealType';
import { EPageType, IPageCTA } from '../../types/redux/page';

export const setQueryParams = actionGenerator<EActionTypes.SetQP, Partial<IParsedQsParams>>(EActionTypes.SetQP);
export const setDealType = actionGenerator<EActionTypes.SetDealType, EDealType>(EActionTypes.SetDealType);
export const toggleStickyFooterVisible = actionGenerator<EActionTypes.ToggleStickyFooterVisible, boolean>(
  EActionTypes.ToggleStickyFooterVisible,
);

export const setPageCta = actionGenerator<EActionTypes.SetPageCta, Partial<IPageCTA>>(EActionTypes.SetPageCta);

export type TSetQueryParamsAction = ReturnType<typeof setQueryParams>;
export type TSetDealTypeAction = ReturnType<typeof setDealType>;
export type TToggleStickyFooterVisibleAction = ReturnType<typeof toggleStickyFooterVisible>;

export const clearIsFromOfferCard = actionGenerator<EActionTypes.ClearIsFromOfferCard>(
  EActionTypes.ClearIsFromOfferCard,
);
export const setMinGeoId = actionGenerator<EActionTypes.SetMinGeoId, number>(EActionTypes.SetMinGeoId);
export const setPageType = actionGenerator<EActionTypes.SetPageType, EPageType>(EActionTypes.SetPageType);

export type TClearIsFromOfferCard = ReturnType<typeof clearIsFromOfferCard>;

export type TPageActions =
  | TSetQueryParamsAction
  | TSetDealTypeAction
  | TToggleStickyFooterVisibleAction
  | ReturnType<typeof setPageCta>
  | ReturnType<typeof setMinGeoId>
  | ReturnType<typeof setPageType>
  | TClearIsFromOfferCard;
